import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from '@env/environment';

import { DealModel } from '@app/core/models';
import { IDealApiModel } from '@app/core/models/api';

@Injectable()
export class DealApiService {
  constructor(private http: HttpClient) {}

  getCoupon(req: { id: string } | { slug: string }): Observable<DealModel> {
    const params = new HttpParams({ fromObject: req });

    return this.http
      .get<IDealApiModel>(`${environment.API_URL}v5/coupon.json`, {
        params,
      })
      .pipe(map(res => new DealModel(res)));
  }

  getClusterCoupons(cluster: number | string): Observable<Array<DealModel>> {
    const params = new HttpParams({
      fromObject: {
        cluster: `${cluster}`,
      },
    });

    return this.http
      .get<Array<IDealApiModel>>(`${environment.API_URL}v5/coupons.json`, {
        params,
      })
      .pipe(map(res => res.map(item => new DealModel(item))));
  }
}
